import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './pricedup.features';
import { themeColors } from './pricedup.config';
import { PricedUpLogotype } from './pricedup.logotype';
import { PricedUpLogo } from 'src/layouts/LoginPage/logos/PricedUpLogo';
import PricedUpLoginImage from 'src/layouts/LoginPage/loginBgImages/PricedUpLoginImage.jpg';
import { PricedUpBrandIconWrapper, CompliancePopupLogo } from './pricedup.style';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'PricedUp Backoffice',
    urls: {
        website: 'https://pricedup.bet/',
        backoffice: 'https://backoffice.pricedup.bet/',
    },
    BrandIcon: () => <PricedUpBrandIconWrapper />,
    Logotype: () => <PricedUpLogotype />,
    LogotypeLoginPage: () => <PricedUpLogo />,
    compliancePopupLogo: () => <CompliancePopupLogo />,
    loginImageContainer: () => <LoginImageWrapper imgSrc={PricedUpLoginImage} />,
};
